import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { classNames, format } from '@dt/fe-utils'
import { decorationMobx } from '@mobxStore'
import { modalLayer } from '@utils'
import CashierController from '@ctrls/cashierController'
import { Icon } from '@cps'
import { FullOffModal } from '../../modal'
import './index.scss'

interface IProps {
  scene?: 'menu' | 'checkout';
}

const FullOffBar: React.FC<IProps> = ({ scene = 'menu' }) => {
  const { designatedBuyAgain } = discountMobx.discountResult

  // 满减信息透出
  const getRuleInfo = useMemo(() => {
    if (!designatedBuyAgain) return ''
    const { nowOff, buyAgainFee, nextDiscountFee } = discountMobx.discountResult?.designatedBuyAgain
    if (nowOff && !buyAgainFee) {
      return i18n.t('menu.fullOff.cartFullOff3', { z: format.toPrice(nowOff) })
    }
    if (!nowOff) {
      return i18n.t('menu.fullOff.cartFullOff1', { x: format.toPrice(buyAgainFee), y: format.toPrice(nextDiscountFee) })
    }
    return i18n.t('menu.fullOff.cartFullOff2', { x: format.toPrice(buyAgainFee), y: format.toPrice(nextDiscountFee), z: format.toPrice(nowOff) })
  }, [discountMobx.discountResult])

  // 去凑单
  const handleToFullOff = () => {
    if ((designatedBuyAgain.isAllCombo && designatedBuyAgain.isAllProduct) || !designatedBuyAgain.activityProducts?.length || !designatedBuyAgain.nextDiscountFee) {
      return
    }
    modalLayer(FullOffModal, { }).then((product: any) => {
      CashierController.handleProductToCart({
        type: 'add',
        product,
        isAddProduct: true
      })
    }).catch(() => {
    })
  }

  if (!designatedBuyAgain) {
    return null
  }

  return (
    <div className={classNames(`fulloff-bar scene-${scene}`, { floattabbar: decorationMobx.fullOfBarAndTabBar, notabbar: !decorationMobx.tabBarVisible })} onClick={handleToFullOff}>
      <span className='tag'>{i18n.t('menu.fullOff.tag')}</span>
      <span className='info'>{getRuleInfo}</span>
      {
        (designatedBuyAgain.isAllCombo && designatedBuyAgain.isAllProduct) || !designatedBuyAgain.activityProducts?.length || !designatedBuyAgain.nextDiscountFee ? null : (
          <span className='btn-icon'>
            {i18n.t('menu.fullOff.addOn')}
            <Icon name='chevron-right' />
          </span>
        )
      }
    </div>
  )
}

export default observer(FullOffBar)
